import React from 'react'

const ArrowUpgrade = (props) => (
  <svg width="9" height="11" viewBox="0 0 9 11" fill={props.color ? props.color : '#FFC736'} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.96083 10.6855L4.96083 2.99673L7.24365 5.25852L8.14024 4.3677L4.32495 0.576989L0.509644 4.3677L1.40624 5.25851L3.68906 2.99673L3.68906 10.6855L4.96083 10.6855Z"/>
  </svg>
)

export default ArrowUpgrade
